import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IVariablesClient, VariablesClient } from "app/ApiClient";
import { IState } from "slices";
import { LoadingState } from "types";
import { initialStemsState } from "./stemsState";

const variablesClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);

export const getStems = createAsyncThunk(
  "stems/getStems",
  async ({ projectId, versionId }: { projectId: number; versionId: string }, { rejectWithValue }) => {
    try {
      const result = await variablesClient.getStems(projectId, versionId);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const stemsSlice = createSlice({
  name: "stems",
  initialState: initialStemsState,
  reducers: {
    resetStems: () => initialStemsState,
  },
  extraReducers: (builder) => {
    // getStems
    builder.addCase(getStems.pending, (state) => {
      state.stems = [];
      state.loading = LoadingState.pending;
    });
    builder.addCase(getStems.fulfilled, (state, { payload }) => {
      state.stems = payload || [];
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getStems.rejected, (state) => {
      state.stems = [];
      state.loading = LoadingState.failed;
    });
  },
});
export const { resetStems } = stemsSlice.actions;
export const brandsSelector = (state: IState) => state.stems;
export default stemsSlice.reducer;
